import React from 'react';
import { render } from 'react-dom';

//Import Css files
import './index.css';
import './services/AxiosMiddleware';

//Sentry integration
import './services/sentry'

//Import App Components
import App from './App';
import ReactGA from 'react-ga';

//import registerServiceWorker from './registerServiceWorker';

// import { IntlProvider } from 'react-intl-redux'
// import { addLocaleData } from 'react-intl'

import { Provider } from 'react-redux'

import { ConnectedRouter } from 'connected-react-router';
import configureStore from './services/ConfigureStore'

import history from './services/History';


//Initial state
import { initialState } from './store/InitialState';

const store = configureStore(initialState)
// Store state in localStorage after each event
store.subscribe(() => {
    //localStorage.setItem('saved_store_state', JSON.stringify(store.getState()));
});

// listen for route changes
history.listen((location, action) => {
    // Google analytics initalization
    if (document.getElementById('builder-gtag')) {
        ReactGA.initialize(document.getElementById('builder-gtag').getAttribute('data-id'));
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(window.location.hash);
    }
})

export default store;





const target = document.querySelector('#root') || document.createElement('div');
//if div tag is not exists with root id in test environment
target.setAttribute("id", "root");
render(<Provider store={store} > { /* <IntlProvider> */}
    <ConnectedRouter history={history} >
        <App history={history} />
    </ConnectedRouter> { /* </IntlProvider> */} </Provider>,
    target
);

//Unregister service workers
try {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            registration.unregister().then((success) => {
                if (success) {
                    console.log('Service worker unregistered successfully:', registration.scope);
                }
            });
        });
    });
} catch (error) {
    console.error('An unexpected error occurred:', error);
}



//registerServiceWorker();